import React, { useState } from 'react';
import { ArrowLeftIcon, UserIcon, MessageCircleIcon, EyeIcon, TagIcon, ThumbsUpIcon, ReplyIcon, EditIcon, TrashIcon, PinIcon, LockIcon, CheckCircleIcon, SendIcon, Trash2 } from 'lucide-react';
const TeacherTopicDetail = ({
  topic,
  onBack,
  isTeacher = false,
  onDeleteTopic
}) => {
  const [replyContent, setReplyContent] = useState('');
  const [replies, setReplies] = useState([{
    id: 1,
    author: 'Ahmet Yılmaz (Öğretmen)',
    authorType: 'teacher',
    content: 'Matematik dersinde öğrencilerin ilgisini çekmek için günlük hayattan örnekler vermek ve interaktif uygulamalar kullanmak oldukça etkili oluyor. Ayrıca grup çalışmaları da motivasyonu artırıyor.',
    date: '2 saat önce',
    likes: 12,
    isTeacher: true,
    isOfficial: true
  }, {
    id: 2,
    author: 'Zeynep Çelik',
    authorType: 'student',
    content: 'Ben derslerimde matematik oyunları kullanıyorum ve öğrencilerin çok ilgisini çekiyor. Özellikle rekabet içeren aktiviteler motivasyonu artırıyor.',
    date: '1 saat önce',
    likes: 8,
    isTeacher: false,
    isOfficial: false
  }, {
    id: 3,
    author: 'Murat Aksoy',
    authorType: 'student',
    content: 'Teknoloji entegrasyonu da çok önemli. GeoGebra gibi uygulamalar soyut kavramları somutlaştırmada yardımcı oluyor.',
    date: '45 dakika önce',
    likes: 5,
    isTeacher: false,
    isOfficial: false
  }]);
  const [isLocked, setIsLocked] = useState(false);
  const showToast = (message, type) => {
    // Simple console log for now, would implement a proper toast system
    console.log(`Toast: ${message} (${type})`);
  };
  const handleSubmitReply = e => {
    e.preventDefault();
    if (replyContent.trim()) {
      const newReply = {
        id: replies.length + 1,
        author: 'Öğretmen',
        authorType: 'teacher',
        content: replyContent,
        date: 'Şimdi',
        likes: 0,
        isTeacher: true,
        isOfficial: false
      };
      setReplies([...replies, newReply]);
      setReplyContent('');
      showToast('Yanıtınız gönderildi!', 'success');
    }
  };
  const handleLikesReply = id => {
    setReplies(replies.map(reply => reply.id === id ? {
      ...reply,
      likes: reply.likes + 1
    } : reply));
    showToast('Yanıtı beğendiniz!', 'success');
  };
  const handleSetOfficial = id => {
    if (isTeacher) {
      setReplies(replies.map(reply => ({
        ...reply,
        isOfficial: reply.id === id
      })));
      showToast('Yanıt öğretmen onaylı olarak işaretlendi!', 'success');
    }
  };
  const handleDeleteReply = id => {
    setReplies(replies.filter(reply => reply.id !== id));
    showToast('Yanıt silindi!', 'success');
  };
  const toggleLockTopic = () => {
    setIsLocked(!isLocked);
    showToast(isLocked ? 'Konu açıldı!' : 'Konu kilitlendi!', 'success');
  };
  return <div className="space-y-6 bg-black min-h-screen" data-id="element-729">
      <div className="flex items-center" data-id="element-730">
        <button onClick={onBack} className="mr-3 p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition-colors" data-id="element-731">
          <ArrowLeftIcon size={18} data-id="element-732" />
        </button>
        <h1 className="text-xl font-bold" data-id="element-733">Konu Detayı</h1>
      </div>
      {/* Main Topic */}
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-emerald-500" data-id="element-734">
        <div className="relative p-6 bg-black rounded-lg h-full" data-id="element-735">
          <div className="flex justify-between items-start" data-id="element-736">
            <div data-id="element-737">
              <h2 className="text-xl font-semibold mb-2" data-id="element-738">{topic.title}</h2>
              <div className="flex items-center space-x-4 text-sm text-gray-400 mb-3" data-id="element-739">
                <div className="flex items-center" data-id="element-740">
                  <UserIcon size={14} className="mr-1" data-id="element-741" />
                  {topic.author}
                </div>
                <div className="flex items-center" data-id="element-742">
                  <MessageCircleIcon size={14} className="mr-1" data-id="element-743" />
                  {topic.replies} yanıt
                </div>
                <div className="flex items-center" data-id="element-744">
                  <EyeIcon size={14} className="mr-1" data-id="element-745" />
                  {topic.views} görüntülenme
                </div>
                <div data-id="element-746">{topic.date}</div>
              </div>
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-747">
                {topic.tags && topic.tags.map((tag, i) => <div key={i} className="flex items-center text-xs bg-gray-800 text-emerald-400 px-2 py-1 rounded-full" data-id="element-748">
                      <TagIcon size={12} className="mr-1" data-id="element-749" />
                      {tag}
                    </div>)}
              </div>
            </div>
            <div className="flex space-x-2" data-id="element-750">
              <button className="p-1.5 bg-gray-800 text-gray-400 hover:text-emerald-400 hover:bg-gray-700 rounded transition-colors" data-id="element-751">
                <EditIcon size={16} data-id="element-752" />
              </button>
              {/* ÖĞRETMEN YETKİSİ - KONU SİLME */}
              {isTeacher && onDeleteTopic && <button onClick={() => onDeleteTopic(topic.id)} className="p-1.5 bg-red-500/20 text-red-400 hover:bg-red-500/30 rounded transition-colors" data-id="element-753">
                  <TrashIcon size={16} data-id="element-754" />
                </button>}
              <button className={`p-1.5 ${isLocked ? 'bg-red-900/20 text-red-400' : 'bg-gray-800 text-gray-400 hover:text-amber-400 hover:bg-gray-700'} rounded transition-colors`} onClick={toggleLockTopic} title={isLocked ? 'Konuyu Aç' : 'Konuyu Kilitle'} data-id="element-755">
                <LockIcon size={16} data-id="element-756" />
              </button>
            </div>
          </div>
          <div className="mt-4 border-t border-gray-800 pt-4" data-id="element-757">
            <p className="text-gray-300" data-id="element-758">
              Öğrencilerin matematik dersine ilgisini artırmak için etkili
              yöntemler nelerdir? Özellikle soyut konularda motivasyonu nasıl
              yüksek tutabiliriz? Deneyimlerinizi ve önerilerinizi paylaşırsanız
              sevinirim.
            </p>
          </div>
        </div>
      </div>
      {/* Replies */}
      <div className="space-y-4" data-id="element-759">
        <h3 className="text-lg font-medium flex items-center" data-id="element-760">
          <MessageCircleIcon size={18} className="mr-2 text-emerald-400" data-id="element-761" />
          Yanıtlar
        </h3>
        {replies.sort((a, b) => {
        // Official replies always come first
        if (a.isOfficial && !b.isOfficial) return -1;
        if (!a.isOfficial && b.isOfficial) return 1;
        return 0;
      }).map(reply => <div key={reply.id} className={`relative ${reply.isOfficial ? 'p-[2px] bg-gradient-to-r from-emerald-600 to-emerald-500' : reply.isTeacher ? 'p-[1px] bg-gradient-to-r from-emerald-600/50 to-emerald-500/50' : 'p-[1px] bg-gradient-to-r from-gray-700/50 to-gray-600/50'} rounded-lg overflow-hidden`} data-id="element-762">
              <div className="relative p-4 bg-black rounded-lg h-full" data-id="element-763">
                {reply.isOfficial && <div className="absolute top-0 right-0 bg-emerald-600 text-white text-xs px-3 py-1 rounded-bl-lg" data-id="element-764">
                    <div className="flex items-center" data-id="element-765">
                      <CheckCircleIcon size={12} className="mr-1" data-id="element-766" />
                      Öğretmen Onaylı
                    </div>
                  </div>}
                <div className="flex justify-between items-start" data-id="element-767">
                  <div className="flex items-center" data-id="element-768">
                    <div className={`h-10 w-10 rounded-full ${reply.isTeacher ? 'bg-emerald-900/40 text-emerald-400' : 'bg-gray-800 text-gray-300'} flex items-center justify-center mr-3`} data-id="element-769">
                      {reply.author.charAt(0)}
                    </div>
                    <div data-id="element-770">
                      <h4 className={`font-medium ${reply.isTeacher ? 'text-emerald-400' : 'text-white'}`} data-id="element-771">
                        {reply.author}
                      </h4>
                      <p className="text-xs text-gray-400" data-id="element-772">{reply.date}</p>
                    </div>
                  </div>
                  <div className="flex space-x-2" data-id="element-773">
                    {!reply.isOfficial && isTeacher && <button className="p-1.5 bg-gray-800 text-gray-400 hover:text-emerald-400 hover:bg-gray-700 rounded transition-colors" onClick={() => handleSetOfficial(reply.id)} title="Resmi Yanıt Olarak Sabitle" data-id="element-774">
                        <PinIcon size={16} data-id="element-775" />
                      </button>}
                    {/* ÖĞRETMEN YETKİSİ - YANIT SİLME */}
                    {isTeacher && <button onClick={() => handleDeleteReply(reply.id)} className="p-1.5 bg-gray-800 text-gray-400 hover:text-red-400 hover:bg-gray-700 rounded transition-colors" title="Yanıtı Sil" data-id="element-776">
                        <Trash2 size={16} data-id="element-777" />
                      </button>}
                  </div>
                </div>
                <div className="mt-3 pl-13" data-id="element-778">
                  <p className="text-gray-300" data-id="element-779">{reply.content}</p>
                  <div className="mt-3 flex items-center space-x-4" data-id="element-780">
                    <button className="flex items-center text-gray-400 hover:text-emerald-400" onClick={() => handleLikesReply(reply.id)} data-id="element-781">
                      <ThumbsUpIcon size={14} className="mr-1" data-id="element-782" />
                      <span className="text-sm" data-id="element-783">{reply.likes}</span>
                    </button>
                    <button className="flex items-center text-gray-400 hover:text-emerald-400" data-id="element-784">
                      <ReplyIcon size={14} className="mr-1" data-id="element-785" />
                      <span className="text-sm" data-id="element-786">Yanıtla</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>)}
      </div>
      {/* Reply Form */}
      {!isLocked ? <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600/50 to-emerald-500/50" data-id="element-787">
          <div className="relative p-4 bg-black rounded-lg h-full" data-id="element-788">
            <h3 className="text-lg font-medium mb-3" data-id="element-789">Yanıt Yaz</h3>
            <form onSubmit={handleSubmitReply} data-id="element-790">
              <div className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/40 to-emerald-500/40" data-id="element-791">
                <textarea value={replyContent} onChange={e => setReplyContent(e.target.value)} placeholder="Yanıtınızı buraya yazın..." rows={4} className="w-full bg-gray-900 rounded-md py-2 px-3 focus:outline-none" required data-id="element-792"></textarea>
              </div>
              <div className="mt-3 flex justify-end" data-id="element-793">
                <button type="submit" className="bg-emerald-600 hover:bg-emerald-500 text-white px-4 py-2 rounded-md flex items-center transition-colors" data-id="element-794">
                  <SendIcon size={16} className="mr-2" data-id="element-795" />
                  Yanıt Gönder
                </button>
              </div>
            </form>
          </div>
        </div> : <div className="bg-gray-900/50 border border-red-500/30 text-center p-4 rounded-lg" data-id="element-796">
          <div className="flex items-center justify-center text-red-400 mb-1" data-id="element-797">
            <LockIcon size={18} className="mr-2" data-id="element-798" />
            <span className="font-medium" data-id="element-799">Bu konu kilitlenmiştir</span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-800">Yeni yanıt eklenemez</p>
        </div>}
    </div>;
};
export default TeacherTopicDetail;